import { render } from "./HowWeWork.vue?vue&type=template&id=9fd12164&scoped=true"
import script from "./HowWeWork.vue?vue&type=script&lang=js"
export * from "./HowWeWork.vue?vue&type=script&lang=js"

import "./HowWeWork.vue?vue&type=style&index=0&id=9fd12164&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fd12164"]])

export default __exports__